import TagChip from './TagChip';

export default TagChip;
